import { IconButton, IconButtonProps, styled } from '@mui/material';
import { LinkProps } from 'react-router-dom';

export const IconButtonLinkStyled = styled(IconButton)<
  IconButtonProps & LinkProps
>(() => ({
  '&:hover': { color: 'inherit' },
}));
